require('./brokerCustomWalletCreate.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const {browserHistory} = require('react-router-dom');
// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
// @helpers
const { FormattedText } = require('core/i18n').i18n;
// @ components
const BrokerCustomWalletPortfolioEmptyState =  require('../brokerCustomWalletPortfolioEmptyState/brokerCustomWalletPortfolioEmptyState');
const { BrokerCustomWalletEditablePortfolio } = require('../brokerCustomWalletEditablePortfolio/brokerCustomWalletEditablePortfolioContainer');
const { BrokerCustomWalletInterveners } = require('../brokerCustomWalletInterveners/brokerCustomWalletIntervenersContainer');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ constants
const { 
    BROKER_CUSTOM_WALLET_CONFIGURATION_URL,
    BROKER_MYPROFILE_MYWALLET_URL,
    MYPROFILE_BROKER_EXPLORE_URL
} = require('constants/index');
// @ utils
const { formatText } = require('core/i18n').i18n;

class BrokerCustomWalletCreate extends React.Component {
    constructor(props) {
        super(props);
        this.handlePortfolioClick = this.handlePortfolioClick.bind(this);
        this.cancelCreate = this.cancelCreate.bind(this);
    }

    componentDidMount() {
        this.props.init();
        const fetchMyInvestments = this.props.fetchMyInvestments() || false;

        if (fetchMyInvestments) {
            fetchMyInvestments.then(this.props.getContractsList)
            .catch(this.props.getContractsList);
        } else {
            this.props.getContractsList();
        }
    }

    handlePortfolioClick() {
        return;
    }

    saveCallbacks() {
        return {
            successCallback: () => {
                browserHistory.push(BROKER_CUSTOM_WALLET_CONFIGURATION_URL);
            },
            errorCallback: () => {}
        }
    }

    cancelCreate() {
        this.props.cancelEdition();
        browserHistory.push(BROKER_CUSTOM_WALLET_CONFIGURATION_URL);
    }

    showContent() {
        const saveCallbacks = this.saveCallbacks();
        return (
            <div className="custom-wallet-create-view">
                <BrokerCustomWalletEditablePortfolio
                    saveCallbacks={saveCallbacks}
                    handleCancelClick={this.cancelCreate}
                    actionsAvailable={false}
                    creatingNew={true}
                    defaultViewAvailable={true}
                />
                <BrokerCustomWalletInterveners />
            </div>
        );
    }

    showLoadingSection() {
        return (
            <LoadingSection />
        );
    }

    render() {
        const { immBrokerCustomWalletEditablePortfolio } = this.props;
        const cwBoxTitle = formatText('brokerCustomWallet-configureNewView');
        let content = this.showLoadingSection();
        const contractRequest = this.props.immBrokerCustomWalletEditablePortfolio.get('contractRequest');
        const onlyUnconsolidatedContracts = immBrokerCustomWalletEditablePortfolio.getIn(['validation', 'onlyUnconsolidatedContracts']);
        
        if (contractRequest.get('isFetching')) {
            content = this.showLoadingSection();
        } else if (contractRequest.get('failure')) {
            content = (
                <div>
                    <BrokerCustomWalletPortfolioEmptyState />
                    <OKLink modifier="emphasize" extraClass={'custom-wallet-create__wallet-link'} to={BROKER_MYPROFILE_MYWALLET_URL}>
                        <FormattedText value="broker-callMeBackGoToMyInvestments" />
                    </OKLink>
                </div>
            );
        } else if (onlyUnconsolidatedContracts){
            content = (
                <div>
                    <BrokerCustomWalletPortfolioEmptyState isEmptyState={true} />
                    <OKLink modifier="emphasize" extraClass={'custom-wallet-create__wallet-link'} to={MYPROFILE_BROKER_EXPLORE_URL}>
                        <FormattedText value="brokerCustomWallet-contractEmptyStateLink"/>
                    </OKLink>
                </div>
            );
        } else if (contractRequest.get('success')) {
            content = this.showContent(cwBoxTitle);
        }

        return (
            <ContentBox title={cwBoxTitle} hasShadow={false} smallTitle={true}>
                {content}
            </ContentBox>
        );
    }
}

BrokerCustomWalletCreate.propTypes = {
    immBrokerCustomWalletEditablePortfolio: PropTypes.any.isRequired,
    init: PropTypes.func.isRequired,
    getContractsList: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    cancelEdition: PropTypes.func.isRequired
};

module.exports = BrokerCustomWalletCreate;
